import { render } from "./search-comp.vue?vue&type=template&id=0b3bbe2c&scoped=true"
import script from "./search-comp.vue?vue&type=script&lang=js"
export * from "./search-comp.vue?vue&type=script&lang=js"

import "./search-comp.vue?vue&type=style&index=0&id=0b3bbe2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3bbe2c"]])

export default __exports__